import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getGiftCards = async (salonId: string | undefined) => {
  const { data, error } = await supabase
    .from('gift_cards')
    .select(`
      *,
      services:service_type (
        name
      )
    `)
    .eq('salon_id', salonId)
    .eq('status', 'Open')

  if (error) {
    throw new Error(error.message)
  }
  console.log('gift cards', data)
  return data
}

export default function useGetGiftCardsBySalonId(salonId: string | undefined) {
  return useQuery({
    queryKey: ['salonGiftCards', salonId],
    queryFn: () => getGiftCards(salonId),
    staleTime: 0,
    enabled: !!salonId
  })
} 